import React from 'react';
import ReactSlick from 'react-slick';
import ErrorBoundary from '../../../ErrorBoundary';
import Product from '../../../reusable-components/Product/Product';
import ArrowSvg from '../../../sharedSvgs/ArrowSvg';

import '../style/productSlider.scss';

function PrevArrow({ className, onClick }) {
  return (
    <div
      className={`${className} arrowLeft arrowSlider`}
      aria-label="Previous Slide"
      onClick={onClick}
      role="button"
      tabIndex="0"
    >
      <span className="icon-direction-white-left" />
    </div>
  );
}

function NextArrow({ className, onClick }) {
  return (
    <div
      className={`${className} arrowRight arrowSlider`}
      aria-label="Next Slide"
      onClick={onClick}
      role="button"
      tabIndex="0"
    >
      <span className="icon-direction-white-right" />
    </div>
  );
}

function RoundPrevArrow({ className, onClick }) {
  return (
    <div
      className={`${className}  roundBgArrow-prev`}
      onClick={onClick}
      role="button"
      tabIndex="0"
      style={{ outline: 'none' }}
    >
      <div className="background">
        <ArrowSvg direction="prev" />
      </div>
    </div>
  );
}

function RoundNextArrow({ className, onClick }) {
  return (
    <div
      className={`${className} roundBgArrow-next`}
      onClick={onClick}
      role="button"
      tabIndex="0"
      style={{ outline: 'none' }}
    >
      <div className="background">
        <ArrowSvg direction="next" />
      </div>
    </div>
  );
}

class ProductSlider extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isDragging: false,
      windowWidth: window.innerWidth,
    };
  }

  componentDidMount() {
    window.addEventListener('touchstart', this.touchStart);
    window.addEventListener('touchmove', this.preventTouch, { passive: false });
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('touchstart', this.touchStart);
    window.removeEventListener('touchmove', this.preventTouch, {
      passive: false,
    });
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () =>
    this.setState({
      windowWidth: window.innerWidth,
    });

  touchStart(e) {
    if (e.touches && e.touches.length) {
      this.firstClientX = e.touches[0].clientX;
    }
  }

  preventTouch(e) {
    const minValue = 5; // threshold
    const element = e.touches[0].target.offsetParent;

    this.clientX = e.touches[0].clientX - this.firstClientX;

    // Vertical scrolling does not work when you start swiping horizontally.
    if (Math.abs(this.clientX) > minValue) {
      if (
        element !== null &&
        element !== undefined &&
        (element.className === 'sliderProduct' ||
          element.className === 'hero-holder')
      ) {
        e.preventDefault();
        return false;
      }
    }
    return false;
  }

  render() {
    const { products } = this.props;
    let settings = {};
    if (products) {
      settings = {
        slidesToShow: 2,
        slidesToScroll: 2,
      };
    } else if (
      !products &&
      this.state.windowWidth <= 320 &&
      this.state.windowWidth < 375
    ) {
      settings = {
        arrows: false,
        slidesToShow: 1.8,
        slidesToScroll: 2,
      };
    } else if (
      !products &&
      this.state.windowWidth >= 321 &&
      this.state.windowWidth < 375
    ) {
      settings = {
        arrows: false,
        slidesToShow: 1.9,
        slidesToScroll: 2,
      };
    } else if (
      !products &&
      this.state.windowWidth >= 375 &&
      this.state.windowWidth < 410
    ) {
      settings = {
        arrows: false,
        slidesToShow: 2.1,
        slidesToScroll: 2,
      };
    } else if (
      !products &&
      this.state.windowWidth >= 410 &&
      this.state.windowWidth < 425
    ) {
      settings = {
        arrows: false,
        slidesToShow: 2.3,
        slidesToScroll: 2,
      };
    } else if (
      !products &&
      this.state.windowWidth >= 425 &&
      this.state.windowWidth < 768
    ) {
      settings = {
        arrows: false,
        slidesToShow: 2.4,
        slidesToScroll: 2,
      };
    } else {
      settings = {
        arrows: false,
        slidesToShow: 2.1,
        slidesToScroll: 2,
      };
    }

    let prevArrow;
    let nextArrow;
    if (products) {
      prevArrow = <PrevArrow />;
      nextArrow = <NextArrow />;
    } else {
      prevArrow = <RoundPrevArrow />;
      nextArrow = <RoundNextArrow />;
    }
    const params = {
      slidesToShow: 5,
      slidesToScroll: 5,
      dots: false,
      arrows: true,
      prevArrow,
      nextArrow,
      infinite: false,
      lazyLoad: true,
      touchThreshold: 15,
      speed: 300,
      beforeChange: () => this.setState({ isDragging: true }),
      afterChange: () => this.setState({ isDragging: false }),
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
          },
        },
        {
          breakpoint: 480,
          settings,
        },
      ],
    };
    return (
      <div
        className={products ? 'productSlider' : 'productSlider storySlider'}
        id="productSlider"
      >
        <div className={products ? 'container' : 'stories-container container'}>
          <div className="productSliderWrapper" data-name="productSlider">
            <ReactSlick {...params}>
              {products
                ? products.map((product, i) => {
                    return (
                      <div key={`${product.id}-${this.props.addToCartCta}`}>
                        <ErrorBoundary
                          location="productslider"
                          errorComponent={null}
                        >
                          <Product
                            isDragging={this.state.isDragging}
                            refId={this.props.refId}
                            refPos={i}
                            product={product}
                            goToProductDataCta={this.props.goToProductDataCta}
                            addToCartCta={this.props.addToCartCta}
                            handleSubmit={this.props.handleSubmit}
                            // addToCartForm={this.props.addToCartForm}
                            sliderType={this.props.sliderType}
                            slickSlider
                            productClick={this.props.productClick}
                          />
                        </ErrorBoundary>
                      </div>
                    );
                  })
                : this.props.children}
            </ReactSlick>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductSlider;
